declare global {
  interface Window {
    fbq: any
    _fbq: any
  }
}

const PIXEL_ID = '1703383767307378'

export function initPixel() {
  if (typeof window === 'undefined') return
  if (window.fbq) return

  /* fbq stub */
  const f: any = function (...args: any[]) {
    f.callMethod ? f.callMethod.apply(f, args) : f.queue.push(args)
  }
  f.push = f
  f.loaded = true
  f.version = '2.0'
  f.queue = [] as any[]

  window.fbq = f
  window._fbq = f

  /* Load the FB pixel script */
  const script = document.createElement('script')
  script.async = true
  script.src = 'https://connect.facebook.net/en_US/fbevents.js'
  document.head.appendChild(script)

  /* Init and track */
  window.fbq('init', PIXEL_ID)
  window.fbq('track', 'PageView')
}

export function trackAddToCart() {
  if (typeof window !== 'undefined' && window.fbq) {
    window.fbq('track', 'AddToCart')
  }
}
